<div class="switch" role="group" [attr.aria-label]="'ui.language.label' | transloco">
  <button
    type="button"
    lang="en"
    [id]="elementId() + '-en-btn'"
    [class.active]="language.lang() === 'en'"
    [attr.aria-pressed]="language.lang() === 'en'"
    (click)="use('en')"
  >
    EN
  </button>
  <button
    type="button"
    lang="ar"
    class="ar"
    [id]="elementId() + '-ar-btn'"
    [class.active]="language.lang() === 'ar'"
    [attr.aria-pressed]="language.lang() === 'ar'"
    (click)="use('ar')"
  >
    عربي
  </button>
</div>
